import styled from 'styled-components';

export const ManualTemplateListItemTitle = styled.div`
    padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
    width: 100%;
    background-color: ${({ theme }) => theme.tokens.BaseColorGray50};
    border-radius: ${({ theme }) => theme.spacing(0.5)};
`;

export const ManualTemplateListItem = styled.div<{ $selected?: boolean }>`
    padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing(2)};
    cursor: pointer;
    box-shadow: ${({ theme, $selected }) =>
        `inset ${theme.spacing(0.5)} 0 0 ${$selected ? theme.tokens.BaseColorBlue700 : 'transparent'}`};
    transition: border-color 0.2s ease;
    border-bottom: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
    background-color: ${({ theme, $selected }) => ($selected ? theme.tokens.BaseColorBlue50 : 'transparent')};

    & > * {
        width: 100%;
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
    }
`;

export const ManualTemplateListItemHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const ManualTemplateListContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
    border-radius: ${({ theme }) => theme.spacing(0.5)};

    > div:last-child {
        border-bottom: none;
    }
`;
